export const AUDIT_TYPES = {
  BAY_LOCATIONS: 'bay-locations',
  CCC_COMMODITY: 'ccc-commodity',
  CCC_STANDARD: 'ccc-standards',
  CARRIER_RATES: 'carrier-rates',
  CORRECTIVE_ACTION_SUBJECTS: 'corrective-action-subjects',
  CORRECTIVE_ACTION_TYPES: 'corrective-action-types',
  CREDIT_TERMS: 'credit-terms',
  CUSTOMER_CONTACT_TYPE: 'customer-contact-type',
  CUSTOMER_LOGINS: 'customer-login',
  DEDUCTIONS: 'deduction',
  DIRECT_STANDARDS: 'direct-standards',
  DISPATCHERS: 'dispatchers',
  DQF_FILES: 'dqf-files',
  DRIVER: 'driver',
  SAFETY_EMAIL_ADDRESSES: 'safety-email-addresses',
  EQUIPMENT: 'equipment',
  EQUIPMENT_TYPE: 'equipment-type',
  EXTERNAL_CARRIERS: 'carrier',
  FAILED_MAPPINGS: 'failed-mappings',
  FIELD_MAPPINGS: 'field-mappings',
  GWI_MOVE_CONTACTS: 'gwi-move-contacts',
  HANDLING_STANDARD: 'handling-standard',
  INSURANCE_POLICIES: 'insurance-policies',
  INTEGRATION_USERS: 'integration-users',
  LANE_RATES: 'lane-rates',
  LC_GROUPS: 'lc-groups',
  LIEN_HOLDERS: 'lien-holders',
  LOCATION: 'location',
  MAINT_REPORT: 'maint-report',
  MARKET: 'market',
  MESSAGING_GROUP: 'messaging-groups',
  NOTE_TEMPLATES: 'note-templates',
  ORDER: 'order',
  ORGANIZATION: 'organization',
  ORGANIZATION_ADDITIONAL_CHARGES: 'organizationAdditionalCharges',
  OUT_OF_SERVICE_REASONS: 'out-of-service-reasons',
  OWNER: 'owner',
  PER_DIEM_CUSTOM_CONTRACT_RULES: 'per-diem-custom-contract-rules',
  PERMIT_LOCATIONS: 'permit-locations',
  PLATE_TYPE: 'plate-type',
  PRINTER: 'printer',
  QUOTES: 'quote',
  RATE_ZONES: 'rate-zones',
  RENTAL_COMPANIES: 'rental-companies',
  REPAIR_CATEGORIES: 'repair-categories',
  REPAIR_ISSUES: 'repair-issues',
  REPAIR_ORDERS: 'repair-orders',
  RESCHEDULE_REASONS: 'reschedule-reasons',
  DISPATCH_DECLINE_REASONS: 'dispatch-decline-reasons',
  ROLES: 'roles',
  SCHEDULE: 'schedule',
  SCHEDULED_REPORTS: 'scheduled-reports',
  SCHEDULING_TERMINAL: 'scheduling-terminal',
  TENANT: 'tenant',
  TERMINAL_PAYMENT_GOALS: 'terminal-payment-goal',
  TERMINATE_REASONS: 'terminate-reasons',
  TRACE_TERMINAL: 'trace-terminal',
  TRUCK: 'truck',
  TRUCK_MAKES: 'truck-makes',
  TRUCK_PERMIT_RULES: 'truck-permit-rules',
  UNITS_OF_MEASURE: 'units-of-measure',
  USERS: 'user',
  VERTICALS: 'verticals',
  WAREHOUSE: 'warehouse',
  WAREHOUSE_ADDITIONAL_CHARGE: 'warehouse-additional-charge',
  WAREHOUSE_COSTS: 'warehouse-costs',
  WAREHOUSE_INSTRUCTIONS: 'warehouse-instructions',
  WEIGHT_RULES: 'weight-rules',
  YARD_USERS: 'yard-users',
  ORGANIZATION_FUEL_TARIFFS: 'organization-fuel-tariffs',
  INVOICE_LINE_ITEMS: 'invoice-line-items',
  INVOICE_LINE_ITEMS_TYPES: 'invoice-line-item-types',
  DISPATCHER_GROUPS: 'dispatcher-groups',
  // Messaging entities
  MESSAGING_V2_GROUP: 'messaging-v2-group',
  LC_DASHBOARD: 'lc-dashboard',
};

export const AUDIT_TYPE_VARIANTS = {
  MILEAGE_BANDS: 'mileage-bands',
};
